<script>
  import { createEventDispatcher } from 'svelte';
  import { subscriptionStatus } from '../../helper';

  export let productMetaDataId,
    options,
    subscription,
    componentInformationKeys,
    currentUserSubscriptionId,
    currentSubscription,
    upcomingSubscription;

  const dispatch = createEventDispatcher();

  const handleOfferTerms = (productMetaDataId) => dispatch('handleOfferTerms', productMetaDataId);
  const handleProductIdChange = (productMetaDataId) =>
    dispatch('handleProductIdChange', productMetaDataId);

  const handleRadioProductClick = (productId, productGroupName) => {
    window.dataLayer.push({
      event: 'genericTrackingEvent',
      eventCategory: 'Subscription Selection Component',
      eventAction: 'Select product in radio',
      eventLabel: `${productGroupName} group : ${productId} product`,
    });
  };

  const handleRadioButtonChange = (e) => {
    productMetaDataId = parseInt(e.target.value);
    handleRadioProductClick(productMetaDataId, subscription.name);

    handleOfferTerms(productMetaDataId);
    handleProductIdChange(productMetaDataId);
  };

  const showSubscriptionStatus = (productId) =>
    subscriptionStatus(
      productId,
      currentUserSubscriptionId,
      currentSubscription,
      componentInformationKeys,
      upcomingSubscription
    );
</script>

<style lang="scss">
  @use './../styles/sharedStyles' as *;
  @use '../../index' as *;
  $badge-blue: #b9e6ff;

  .ongoing {
    @include ongoing;
  }

  .selectable-product-wrapper {
    border: #edf0f7 solid 0.1rem;
    margin-block-end: spacing(1);
    border-radius: 1rem;
    overflow: hidden;
  }

  .selectable-product {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: spacing(1) 1.2rem;
    position: relative;

    [type='radio']:checked,
    [type='radio']:not(:checked) {
      position: absolute;
      left: 0;
      opacity: 0;
    }

    [type='radio']:checked + label,
    [type='radio']:not(:checked) + label {
      position: relative;
      padding-inline-start: 28px;
      cursor: pointer;
      display: inline-block;
    }

    .options-wrapper {
      max-width: 100%;
      cursor: pointer;
      margin-block-start: -0.5rem;

      .option-header {
        font-weight: 600;
      }

      .option-subheader {
        display: block;
      }

      .option-value {
        font-weight: 500;

        :global(span) {
          color: $orange-50;
        }
      }
    }

    .offer-badge {
      align-items: center;
      background-color: $badge-blue;
      border-radius: 0.4rem;
      color: $black;
      display: flex;
      font-size: 1.3rem;
      font-weight: 600;
      height: fit-content;
      justify-content: center;
      margin-block-start: -4px;
      margin-inline-end: -8px;
      min-height: 2.4rem;
      padding: 0.4rem 0.8rem;
      text-align: center;
    }

    [type='radio']:not(:checked) + label::before {
      position: absolute;
      left: 0;
      top: 0.4rem;
      width: 1.6rem;
      height: 1.6rem;
      background: #fff;
      border: 0.2rem solid $purple-50;
      border-radius: 100%;
      content: '';

      :global([dir='rtl']) & {
        right: 0;
      }
    }

    [type='radio']:checked + label::after {
      display: inline-block;
      position: absolute;
      width: 1.6rem;
      height: 1.6rem;
      top: 0.4rem;
      left: 0;
      background-color: $orange-50;
      color: #fff;
      border-radius: 50%;
      border: 0.2rem solid $orange-50;
      content: '';
      transition: all 0.2s ease;
      @include checkmark($white);

      :global([dir='rtl']) & {
        right: 0;
      }
    }
  }

  .selected-option {
    border: $orange-50 solid 0.1rem;
  }
</style>

{#each options as option}
  <div class="selectable-product-wrapper" class:selected-option={productMetaDataId === option.id}>
    <div class={showSubscriptionStatus(option.id).class}>
      {showSubscriptionStatus(option.id).localisation}
    </div>

    <div class="selectable-product">
      <input
        type="radio"
        checked={productMetaDataId === option.id}
        on:click={handleRadioButtonChange}
        value={option.id}
        id={option.id}
        bind:group={productMetaDataId}
      />
      <label class="options-wrapper" for={option.id}>
        <span class="option-header">{option.header}</span>
        <span class="option-subheader">{option.subheader}</span>
        <span class="option-value">{@html option.value}</span>
      </label>
      {#if option.badge !== ''}
        <div class="offer-badge">
          {option.badge}
        </div>
      {/if}
    </div>
  </div>
{/each}
